import { useGetParams } from '../../hooks/useGetParams';

import styles from './QuizContainer.module.css';

import Advt from '../Advt/Advt';
import Quiz from '../Quiz/Quiz';

import quizBg from '../../assets/video/bgVideo.webm';
import quizBgPoster from '../../assets/images/bgPoster.webp';
import logoBig from '../../assets/images/logoBig.webp';

export const QuizContainer = ({ voteState, currentState }) => {
  const { marginTopQuiz } = useGetParams();

  return (
    <div className={styles.quizWrapper}>
      <Quiz
        variants={voteState?.vars}
        title={voteState?.title}
        questionImgUrl={voteState?.questionImgUrl}
        currentState={currentState}
        marginTopQuiz={marginTopQuiz}
        idVote={voteState?.id}
      />
      <Advt />

      <img src={logoBig} alt="logoBig" className={styles.logoBig} />

      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={quizBgPoster}
      >
        <source src={quizBg} type="video/webm" />
      </video>
    </div>
  );
};
